// @flow

import { cloneDeep } from 'lodash';
import BUILDINGS_STYLE from 'Components/widgets/pick-your-room/wrapper/map/gl-styles/buildings.js';
import { SELECT_BUILDING } from 'Store/pick-your-room/app/pickYourRoom.reducer';

export const PYR_MAP_ERROR = 'PYR_MAP_ERROR';
export const LOAD_STYLE = 'LOAD_STYLE';
export const LOAD_POLYGONS = 'LOAD_POLYGONS';
export const SET_RESORT = 'SET_RESORT_PYR';
export const HIGHLIGHT_BUILDING = 'HIGHLIGHT_BUILDING';
export const TOGGLE_BUILDING_SELECTION = 'TOGGLE_BUILDING_SELECTION';
export const RESET_BUILDING = 'RESET_BUILDING';
export const SELECT_MAP_FLOOR_LEVEL = 'SELECT_MAP_FLOOR_LEVEL';
export const FIT_BOUNDS = 'FIT_BOUNDS';

const initialState = {
  mapStyle: null,
  maxBounds: null,
  amenities: [],
  geoJSON: null,
  currentBounds: null,
  highlightedBuildingId: '',
};

export default function reducer(state: ReduxState = initialState, action: Action<*>) {
  switch (action.type) {
    case PYR_MAP_ERROR: {
      const {
        payload: { error },
      } = action;
      return {
        ...state,
        error: error,
      };
    }
    case LOAD_STYLE: {
      const {
        payload: { mapStyle },
      } = action;
      return {
        ...state,
        mapStyle,
      };
    }
    case SET_RESORT: {
      const {
        payload: { resortData },
      } = action;

      if (!resortData) {
        return state;
      }

      return {
        ...state,
        baseViewport: resortData.initialViewport,
        targetViewport: resortData.targetViewport,
        maxBounds: resortData.maxBounds,
        amenities: resortData.amenities.features,
      };
    }
    case LOAD_POLYGONS: {
      const {
        payload: { geojson: geoJSON },
      } = action;
      const mapStyle = state.mapStyle;
      const layers = [...(mapStyle.layers || []), ...(BUILDINGS_STYLE || [])];
      const layerIndexes = {
        floors: layers.findIndex(layer => layer.id === 'floors'),
        floorsCurrent: layers.findIndex(layer => layer.id === 'floors_current'),
        floorsCurrentDimmed: layers.findIndex(layer => layer.id === 'floors_current_dimmed'),
        floorsHighlight: layers.findIndex(layer => layer.id === 'floors_highlight'),
      };

      const newMapStyle = cloneDeep(state.mapStyle);

      newMapStyle.sources.buildingsSource = { type: 'geojson', data: geoJSON };

      return {
        ...state,
        geoJSON,
        layerIndexes,
        mapStyle: {
          ...newMapStyle,
          layers,
        },
      };
    }
    case SELECT_BUILDING: {
      const {
        payload: { buildingId },
      } = action;
      const { layerIndexes, mapStyle } = state;

      const newMapStyle = cloneDeep(mapStyle);

      newMapStyle.layers[layerIndexes.floors].filter[2] = buildingId;
      newMapStyle.layers[layerIndexes.floorsCurrent].filter[1][2] = buildingId;
      newMapStyle.layers[layerIndexes.floorsCurrentDimmed].filter[1][2] = buildingId;

      return {
        ...state,
        mapStyle: {
          ...mapStyle,
          ...newMapStyle,
        },
      };
    }
    case RESET_BUILDING: {
      const { layerIndexes, mapStyle } = state;

      const newMapStyle = cloneDeep(mapStyle);

      newMapStyle.layers[layerIndexes.floors].filter[2] = '';
      newMapStyle.layers[layerIndexes.floorsCurrent].filter[1][2] = '';
      newMapStyle.layers[layerIndexes.floorsCurrentDimmed].filter[1][2] = '';

      return {
        ...state,
        mapStyle: {
          ...mapStyle,
          ...newMapStyle,
        },
        highlightedBuildingId: '',
      };
    }
    case SELECT_MAP_FLOOR_LEVEL: {
      const { layerIndexes, mapStyle } = state;
      const {
        payload: { level },
      } = action;

      const newMapStyle = cloneDeep(mapStyle);

      newMapStyle.layers[layerIndexes.floorsCurrent].filter[2][2] = level;
      newMapStyle.layers[layerIndexes.floorsCurrentDimmed].filter[2][2] = level;

      return {
        ...state,
        mapStyle: {
          ...mapStyle,
          ...newMapStyle,
        },
      };
    }
    case HIGHLIGHT_BUILDING: {
      const { layerIndexes, mapStyle } = state;
      const {
        payload: { buildingId },
      } = action;

      const newMapStyle = cloneDeep(mapStyle);

      newMapStyle.layers[layerIndexes.floorsHighlight].filter[2] = buildingId;

      return {
        ...state,
        mapStyle: {
          ...mapStyle,
          ...newMapStyle,
        },
        highlightedBuildingId: buildingId,
      };
    }
    case TOGGLE_BUILDING_SELECTION: {
      const { layerIndexes, mapStyle } = state;
      const {
        payload: { allow },
      } = action;

      const newMapStyle = cloneDeep(mapStyle);
      newMapStyle.layers[layerIndexes.floors].interactive = allow;

      return {
        ...state,
        mapStyle: newMapStyle,
      };
    }
    case FIT_BOUNDS: {
      const {
        payload: { bounds },
      } = action;

      return {
        ...state,
        currentBounds: bounds,
      };
    }
    default: {
      return state;
    }
  }
}
